var UserViewController = (function () {
    function UserViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.table = {
            sortType: 'name', sortReverse: false, search: '',
            filter: false, filterParams: {}, select_options: {}
        };
        this.users = [];
        this.usersLoaded = false;
        this.exportFired = false;
        this.table.headers = [{
                'Name': 'name', 'Email': 'email', 'Role': 'role', 'Status': 'status'
            }];
        this.socket.forward('config.users', this.$scope);
        this.$scope.$on('socket:config.users', function (event, data) {
            _this.users = data;
            _this.usersLoaded = true;
            _this.buildSelects();
        });
        this.socket.forward('config.admin-user-excel', this.$scope);
        this.$scope.$on('socket:config.admin-user-excel', function (event, data) {
            _this.exportFired = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-USER-PERMISSIONS_" + d + ".xlsx");
                a.click();
            }
        });
    }
    UserViewController.prototype.exportUserPermissions = function () {
        this.exportFired = true;
        this.admin.exportUserPermissions();
    };
    UserViewController.prototype.strict = function () {
        if (this.table.filter) {
            return true;
        }
        else {
            return undefined;
        }
    };
    UserViewController.prototype.buildSelects = function () {
        var _this = this;
        var s = [];
        var r = [];
        angular.forEach(this.users, function (user) {
            if (s.indexOf(user.status) === -1) {
                s.push(user.status);
            }
            var who = _this.admin.getBGName(user.swdr_permissions.role);
            if (r.indexOf(who) === -1) {
                r.push(who);
            }
            user.role = who; //Convert roles for display
        });
        s.sort();
        this.table.select_options.status = s;
        r.sort();
        this.table.select_options.role = r;
    };
    UserViewController.prototype.$onInit = function () {
        this.admin.getUserProfiles();
    };
    UserViewController.prototype.resetFilters = function () {
        delete this.table.filters;
        this.table.filterParams = {};
    };
    UserViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin'];
    return UserViewController;
}());
var UserViewComponent = (function () {
    function UserViewComponent() {
        this.templateUrl = 'users-view.html';
        this.controllerAs = 'vm';
        this.controller = UserViewController;
    }
    return UserViewComponent;
}());
angular
    .module('application')
    .component('viewUserSection', new UserViewComponent());

//# sourceMappingURL=user.view.component.js.map
